import { isTypeObject as e } from "./is-type-object.js";
import { resolve as t } from "@scalar/workspace-store/resolve";
//#region src/schema/helpers/sort-property-names.ts
var n = (e, t) => e.reduce((e, n) => {
	let r = t?.[n];
	return r && (e[n] = r), e;
}, {}), r = new Intl.Collator(void 0), i = /* @__PURE__ */ new WeakMap(), a = Object.freeze([]), o = (n, o, { hideReadOnly: s = !1, hideWriteOnly: c = !1, orderSchemaPropertiesBy: l = "alpha", orderRequiredPropertiesFirst: u = !0 } = {}) => {
	if (!e(n) || !n.properties) return a;
	let d = n.properties, f = n.required, p = o?.propertyName, m = [
		p === void 0 ? "" : `!${p}`,
		s,
		c,
		l,
		u
	].join("|"), h = i.get(d), g = h?.get(m);
	if (g && g.required === f) return g.names;
	let _ = new Set(f || []), v = s || c, y = [];
	for (let e of Object.keys(d)) {
		let n = d[e];
		if (v) {
			let e = t.schema(n);
			if (s && e?.readOnly === !0 || c && e?.writeOnly === !0) continue;
		}
		y.push({
			name: e,
			order: n && typeof n == "object" && "x-order" in n ? n["x-order"] : void 0,
			required: _.has(e),
			discriminator: e === p
		});
	}
	y.sort((e, t) => {
		if (e.discriminator && !t.discriminator) return -1;
		if (!e.discriminator && t.discriminator) return 1;
		if (e.order !== void 0 && t.order !== void 0) return Number(e.order) - Number(t.order);
		if (e.order !== void 0 && t.order === void 0) return -1;
		if (e.order === void 0 && t.order !== void 0) return 1;
		if (u) {
			if (e.required && !t.required) return -1;
			if (!e.required && t.required) return 1;
		}
		return l === "alpha" ? r.compare(e.name, t.name) : 0;
	});
	let b = Object.freeze(y.map((e) => e.name));
	return typeof d == "object" && d && (h ? h.set(m, {
		required: f,
		names: b
	}) : i.set(d, /* @__PURE__ */ new Map([[m, {
		required: f,
		names: b
	}]]))), b;
};
//#endregion
export { n as reduceNamesToObject, o as sortPropertyNames };

//# sourceMappingURL=sort-property-names.js.map